export default "__VITE_ASSET__MV8BM68N__"